import React, { useState } from "react";
import { FaWhatsapp, FaInstagram, FaLinkedin, FaPhone } from "react-icons/fa";

const FloatingSocialMedia = () => {
  const [isOpen, setIsOpen] = useState(false);

  const whatsappNumber = "919840519018";
  const whatsappMessage = "Hello, I'd like to request a demo!";

  return (
    <div className="fixed bottom-6 right-6 z-40">
      {/* Social icons popup */}
      {isOpen && (
        <div className="absolute bottom-20 right-0 bg-white rounded-lg shadow-lg p-4 border border-gray-200 flex flex-col gap-4 mb-2">
          {/* WhatsApp */}
          <a
            href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            className="text-green-600 hover:text-green-800 transition"
            title="Chat on WhatsApp"
          >
            {React.createElement(FaWhatsapp as any, { size: 20 })}
          </a>

          {/* Phone */}
          <a
            href="tel:+919972658838"
            aria-label="Call Us"
            className="text-blue-600 hover:text-blue-800 transition"
            title="Call Us: +91 9972658838"
          >
            {React.createElement(FaPhone as any, { size: 20 })}
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/7hillsts/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="text-pink-500 hover:text-pink-700 transition"
            title="Follow on Instagram"
          >
            {React.createElement(FaInstagram as any, { size: 20 })}
          </a>

          {/* LinkedIn */}
          <a
            href="https://www.linkedin.com/company/75882464/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="text-blue-600 hover:text-blue-800 transition"
            title="Connect on LinkedIn"
          >
            {React.createElement(FaLinkedin as any, { size: 20 })}
          </a>
        </div>
      )}

      {/* Toggle button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-blue-600 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg hover:bg-blue-700 transition"
        aria-label="Open social media"
        title="Open social media"
      >
        {isOpen ? (
          <span className="text-2xl">×</span>
        ) : (
          <span className="text-xl">📱</span>
        )}
      </button>
    </div>
  );
};

export default FloatingSocialMedia;
